var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3282 8.66336C13.3282 11.9954 10.9958 13.6615 8.22353 14.6277C8.07836 14.6769 7.92067 14.6746 7.77703 14.6211C4.99809 13.6615 2.66565 11.9954 2.66565 8.66336V3.99847C2.66565 3.82173 2.73586 3.65222 2.86084 3.52724C2.98581 3.40227 3.15532 3.33206 3.33206 3.33206C4.66489 3.33206 6.33092 2.53236 7.49048 1.51941C7.63166 1.39879 7.81126 1.33252 7.99695 1.33252C8.18264 1.33252 8.36224 1.39879 8.50342 1.51941C9.66964 2.53903 11.329 3.33206 12.6618 3.33206C12.8386 3.33206 13.0081 3.40227 13.1331 3.52724C13.258 3.65222 13.3282 3.82173 13.3282 3.99847V8.66336Z",
    stroke: "#6A7282",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.03981de814794b3f9bfed9f65097b7ef.svg";
export { ForwardRef as ReactComponent };